"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLeaderboardsDateRangeResponseToJSON = exports.GetLeaderboardsDateRangeResponseFromJSONTyped = exports.GetLeaderboardsDateRangeResponseFromJSON = void 0;
var _1 = require("./");
function GetLeaderboardsDateRangeResponseFromJSON(json) {
    return GetLeaderboardsDateRangeResponseFromJSONTyped(json, false);
}
exports.GetLeaderboardsDateRangeResponseFromJSON = GetLeaderboardsDateRangeResponseFromJSON;
function GetLeaderboardsDateRangeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dates': (json['dates'].map(_1.LeaderboardsDateRangeFromJSON)),
    };
}
exports.GetLeaderboardsDateRangeResponseFromJSONTyped = GetLeaderboardsDateRangeResponseFromJSONTyped;
function GetLeaderboardsDateRangeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dates': (value.dates.map(_1.LeaderboardsDateRangeToJSON)),
    };
}
exports.GetLeaderboardsDateRangeResponseToJSON = GetLeaderboardsDateRangeResponseToJSON;
